var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',_vm._l((_vm.docs),function(doc,index){return _c('div',{key:index,staticClass:"bg-white-40 rounded-sm px-30 pt-20 pb-30 mb-20"},[_c('instructions',{attrs:{"title":doc.category,"docs":doc.instruction}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }